<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import { tchMarked } from '@common/Common'
    import type { AttributeDescriptionDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDescriptionDialog'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: AttributeDescriptionDialogViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const name = computed(() => vm.value.name)
    const description = computed(() => vm.value.description)

    const descriptionHtml = computed(() =>
        vm.value.description
            ? tchMarked(vm.value.description)
            : null
    )

    // ---------------- methods ----------------

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>